<template lang="pug">
  modal(:title='modalProps.title || title' @closeModal='closeModal')
    .column
      p.text-normal.text-container(v-html='modalProps.message || message')
      .row.center
        button.main-button.white.continue.m4-right-5(@click='closeModal' type='button')
          | {{ modalProps.leftLabel || leftLabel }}
        button.main-button.no-border(@click='execFun' type='button')
          | {{ modalProps.rightLabel || rightLabel }}
</template>

<script>
import { mapActions, mapState } from 'vuex'

import Modal from '../Modal'

export default {
  components: { Modal },
  props: {
    title: { type: String, required: false },
    message: { type: String, required: false },
    rightLabel: {
      type: String,
      required: false,
      default: function() {
        return this.$t('choiceModal.save')
      }
    },
    leftLabel: {
      type: String,
      required: false,
      default: function() {
        return this.$t('choiceModal.cancel')
      }
    },
    rightFunc: { type: Function, required: false },
    leftFunc: { type: Function, required: false }
  },
  computed: {
    ...mapState({
      modalProps: state => state.behavior.choiceModal.props
    })
  },
  methods: {
    ...mapActions([ 'hideElement' ]),
    closeModal() {
      this.modalProps.leftFunc && this.modalProps.leftFunc()
      this.leftFunc && this.leftFunc()
      this.hideElement({ element: 'choiceModal' })
    },
    execFun() {
      this.modalProps.rightFunc && this.modalProps.rightFunc()
      this.rightFunc && this.rightFunc()
      this.hideElement({ element: 'choiceModal' })
    }
  }
}
</script>

<style lang="scss" scoped>
.discard-modal {
  .modal-container {
    max-width: 464px;
  }
}

.text-container {
  margin: 25px 0 48px;
}

</style>
